import { DEFAULT_BREAKER, DEFAULT_RETRY, DEFAULT_TIMEOUT_MS, } from './types.js';
const NO_AUTH_GET = () => null;
const NO_AUTH_REFRESH = async () => false;
function defaults() {
    return {
        getAccessToken: NO_AUTH_GET,
        onUnauthorized: NO_AUTH_REFRESH,
        retry: { ...DEFAULT_RETRY },
        breaker: { ...DEFAULT_BREAKER },
        timeoutMs: DEFAULT_TIMEOUT_MS,
        baseUrl: '',
    };
}
let current = defaults();
/**
 * One-time wiring. Call from the shell's bootstrap before any request.
 * Idempotent — the most recent call wins.
 */
export function configureHttp(config) {
    current = {
        getAccessToken: config.getAccessToken,
        onUnauthorized: config.onUnauthorized,
        retry: { ...DEFAULT_RETRY, ...config.retry },
        breaker: { ...DEFAULT_BREAKER, ...config.breaker },
        timeoutMs: config.timeoutMs ?? DEFAULT_TIMEOUT_MS,
        baseUrl: config.baseUrl ?? '',
    };
}
/** @internal — for use by the client. */
export function getConfig() {
    return current;
}
/** @internal — for tests. Restores the pre-`configureHttp` state. */
export function _resetConfig() {
    current = defaults();
}
//# sourceMappingURL=config.js.map